<template>
  <v-menu
    v-if="force"
    content-class="pb-dashboard-card-custom-move-action-menu"
    :close-delay="50"
    nudge-top="35"
    open-on-hover
    tile
    top
  >
    <template #activator="{ on: onMenu }">
      <v-tooltip left>
        <template #activator="{ on: onTooltip }">
          <span v-on="onTooltip">
            <v-btn
              fab
              x-small
              elevation="1"
              color="white"
              class="ml-1"
              v-on="onMenu"
              @click="$emit(action, { id })"
            >
              <v-icon color="warning">
                {{ primaryBtnConfig.icon }}
              </v-icon>
            </v-btn>
          </span>
        </template>

        {{ primaryBtnConfig.text }}
      </v-tooltip>
    </template>

    <v-tooltip left>
      <template #activator="{ on: onTooltip }">
        <span v-on="onTooltip">
          <v-btn
            fab
            x-small
            elevation="1"
            color="white"
            class="ml-1"
            v-on="onTooltip"
            @click="$emit(action, { id, force: true })"
          >
            <v-icon
              :style="secondaryBtnConfig.rotation"
              color="warning"
            >
              {{ secondaryBtnConfig.icon }}
            </v-icon>
          </v-btn>
        </span>
      </template>

      {{ secondaryBtnConfig.text }}
    </v-tooltip>
  </v-menu>

  <v-tooltip
    v-else
    top
  >
    <template #activator="{ on }">
      <v-btn
        fab
        x-small
        elevation="1"
        color="white"
        class="ml-1"
        v-on="on"
        @click="$emit(action, { id })"
      >
        <v-icon color="warning">
          {{ primaryBtnConfig.icon }}
        </v-icon>
      </v-btn>
    </template>

    {{ primaryBtnConfig.text }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'PbDashboardCardMoveUpDown',

  props: {
    id: {
      type: [String, Number],
      required: true,
    },

    moveUp: {
      type: Boolean,
      default: true,
    },

    force: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    action() {
      return this.moveUp ? 'move:up' : 'move:down';
    },

    primaryBtnConfig() {
      return {
        icon: this.moveUp ? 'arrow_upward' : 'arrow_downward',
        text: this.moveUp ? 'Move Up' : 'Move Down',
      };
    },

    secondaryBtnConfig() {
      return {
        rotation: `transform: rotate(${this.moveUp ? '-' : ''}90deg);`,
        text: this.moveUp ? 'Move Top' : 'Move Bottom',
        icon: 'double_arrow',
      };
    },
  },
};
</script>

<style lang="css">
.v-menu__content.pb-dashboard-card-custom-move-action-menu {
  box-shadow: none !important;
}
</style>
